import Vue from 'vue'

Vue.component('Snowf', () =>
  import('vue-snowf').then(m => m.default || m)
)
